<app-create-page
  layout="stacked"
  [title]="'pages.settings.alerting.processors.create.title' | transloco"
  [subtitle]="'pages.settings.alerting.processors.create.subtitle' | transloco"
  icon="siren"
  [backLabel]="'pages.settings.alerting.processors.create.back' | transloco"
  [backLink]="['/settings/alerting']">
  <a
    createPageAside
    [href]="docsUrl"
    target="_blank"
    rel="noopener"
    class="inline-flex items-center gap-2 rounded-md text-sm tracking-tight text-zinc-300 transition-colors duration-150 hover:text-zinc-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50">
    <vx-icon name="question" size="md" />
    {{ 'pages.settings.alerting.processors.create.help.setup' | transloco }}
  </a>
  <a
    createPageAside
    [href]="contactUrl"
    target="_blank"
    rel="noopener"
    class="inline-flex items-center gap-2 rounded-md text-sm tracking-tight text-zinc-300 transition-colors duration-150 hover:text-zinc-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50">
    <vx-icon name="chat-circle" size="md" />
    {{ 'pages.settings.alerting.processors.create.help.contact' | transloco }}
  </a>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <vx-card>
      <!-- mt-1.5: a header-less card has no top inset of its own, so the
           first panel mirrors the 6px the body gives the sides and bottom -->
      <vx-panel variant="group" class="mt-1.5">
        <vx-form-field
          [label]="
            'pages.settings.alerting.processors.create.fields.name.label'
              | transloco
          ">
          <vx-input
            formControlName="name"
            autocomplete="off"
            [placeholder]="
              'pages.settings.alerting.processors.create.fields.name.placeholder'
                | transloco
            " />
        </vx-form-field>
      </vx-panel>

      <vx-panel variant="group">
        <app-alert-configuration-wizard
          [configurationFG]="form.controls.configuration" />
      </vx-panel>

      <vx-card-footer>
        <vx-button
          variant="ghost"
          tone="secondary"
          [routerLink]="['/settings/alerting']">
          {{ 'misc.cancelBtn' | transloco }}
        </vx-button>
        <span
          vxCardFooterActions
          [vRequiredRoles]="['alertprocessors.manager']">
          <!-- tooltip on the wrapper: a disabled button swallows pointer events -->
          <span [vxTooltip]="quotaTooltip()">
            <vx-button
              type="submit"
              [disabled]="!hasQuota()"
              [loading]="isSaving()">
              {{
                'pages.settings.alerting.processors.create.submitBtn'
                  | transloco
              }}
            </vx-button>
          </span>
        </span>
      </vx-card-footer>
    </vx-card>
  </form>
</app-create-page>
